import { z } from 'zod';
import { useValidatedLocalStorage } from './storage/useValidatedLocalStorage';

export const useCreateAnother = () =>
    useValidatedLocalStorage({
        key: 'createAnother',
        schema: z.boolean(),
        defaultValue: false,
    });